import type { PartnerBillingProfileResponseDto } from "Infrastructure/Api/Api";
import { Resources, useResource } from "Infrastructure/Translation/Resources";
import { BillingProfileForm } from "Partner/Components/Form/BillingProfileForm";
import { BaseCard } from "Shared/Components/Cards/BaseCard";

const billingProfileResource = Resources.base.partner.detail.billingProfile;

type PartnerBillingProfileFormWidgetProps = {
	partnerId: number;
	data?: PartnerBillingProfileResponseDto[] | null;
};

export function PartnerBillingProfileFormWidget({
	partnerId,
	data,
}: PartnerBillingProfileFormWidgetProps) {
	const { t } = useResource();

	return (
		<BaseCard title={t(billingProfileResource.title)}>
			{data?.length ? (
				data.map((billingProfile) => (
					<BillingProfileForm
						key={billingProfile.id}
						partnerId={partnerId}
						billingProfileData={billingProfile}
					/>
				))
			) : (
				<></>
			)}
		</BaseCard>
	);
}
